export function reloadOnError<T>(importPromise: Promise<T>) {
  return importPromise.catch(() => {
    const THREE_MINUTES = 3 * 60 * 1000;
    const LAST_RELOAD_KEY = 'lastReloadTime';
    const lastReloadTime = parseInt(
      sessionStorage.getItem(LAST_RELOAD_KEY) ?? '0',
      10,
    );

    // If the handling of the same error is happening too soon,
    // then don't reload the page again to avoid infinite reloads,
    // and report this problem as fatal error
    if (Date.now() - lastReloadTime < THREE_MINUTES) {
      sessionStorage.removeItem(LAST_RELOAD_KEY);
      throw new Error('Dynamic import failed');
    }

    sessionStorage.setItem(LAST_RELOAD_KEY, Date.now().toString());
    window.location.reload();
  });
}
